declare const RASA_PUBLIC_SERVICE_API: string

export const SESSION_STORAGE_KEY = 'RASA_SESSION'

export enum SIGNUP_ROUTES {
  BASE = '/',
  VERIFY_EMAIL = '/verify-email',
  BILLING = '/billing',
  ACCOUNT = '/account',
  CANSPAM = '/canspam',
  EMAIL_PREFERENCES = '/email-preferences',
  COMPLETION = '/completion',
}

export const getRouteSequence = (path) => {
  return Object.values(SIGNUP_ROUTES).indexOf(path)
}

export const getPublicServerUrl = (): string => {
  return `${RASA_PUBLIC_SERVICE_API}`
}

export interface CanSpamInfo {
  name: string,
  country: string,
  address: string,
  city: string,
  state: string,
  zip: string,
  timezone: string,
}

export const DEFAULT_TIMEZONE = 'US/Central'
export const DEFAULT_CAN_SPAM_INFO: CanSpamInfo = {
  name: '',
  country: 'United States',
  address: '',
  city: '',
  state: '',
  zip: '',
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TIMEZONE,
}

export interface AccountInfo {
  accountName: string,
  firstName: string,
  lastName: string,
  websiteAddress: string,
  industry: string,
  listSize: string,
}

export const DEFAULT_ACCOUNT_INFO: AccountInfo = {
  accountName: '',
  firstName: '',
  lastName: '',
  websiteAddress: '',
  industry: '',
  listSize: '',
}

export interface EmailPreferencesInfo {
  content_review: boolean,
  generate_report: boolean,
  user_subscribed: boolean,
  schedule_pause: boolean,
}
export const DEFAULT_EMAIL_PREFERENCES_INFO: EmailPreferencesInfo = {
  content_review: true,
  generate_report: true,
  user_subscribed: true,
  schedule_pause: true,
}
